// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__kdC2w","wrapper":"Tabs_wrapper__nFKX3","tab":"Tabs_tab__mb8sC","active":"Tabs_active__IT5bJ"};